module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-0 hover-show-hidden",
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('div', {
    staticClass: "cover-container mb-1"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "",
      "src": _vm.audio.imgSource
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "genre px-1 primary white--text semi-bold hidden"
  }, [_vm._v(_vm._s(_vm.audio.genre))]), _vm._v(" "), (!_vm.player.playlist.slice(_vm.player.position + 1).find(function (v) { return v.id === _vm.audio.id; })) ? _c('v-btn', {
    key: "watch-later",
    staticClass: "watch-later hidden ma-1",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    },
    on: {
      "click": _vm.addToNextUp
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("queue_music")])], 1) : _c('v-btn', {
    key: "in-watch-later",
    staticClass: "in-watch-later hidden ma-1",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), (_vm.actions.play) ? _c('div', {
    staticClass: "play-pause hidden"
  }, [(_vm.$store.getters.audio && (_vm.audio.id === _vm.$store.getters.audio.id) && (_vm.player.state === 1)) ? _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('pause')
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1) : _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('playAudio', _vm.audio)
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'white--text': _vm.$vuetify.dark, 'black--text': !_vm.$vuetify.dark,
    },
    staticStyle: {
      "text-decoration": "none",
      "position": "relative"
    },
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 truncate-2 semi-bold",
    attrs: {
      "shrink": ""
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.audio.name
    }
  }, [_vm._v(_vm._s(_vm.audio.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 hidden more-vert",
    attrs: {
      "shrink": ""
    }
  }, [_c('v-btn', {
    staticClass: "right ma-0 pa-0 no-hover-opacity",
    attrs: {
      "id": ("btn-more-" + _vm._uid),
      "small": "",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.menuMore = !_vm.menuMore
      }
    }
  }, [_c('v-icon', {
    staticClass: "no-transition"
  }, [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "activator": ("#btn-more-" + _vm._uid)
    },
    model: {
      value: (_vm.menuMore),
      callback: function($$v) {
        _vm.menuMore = $$v
      },
      expression: "menuMore"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-title', {
    on: {
      "click": _vm.atp
    }
  }, [_vm._v("Add to")])], 1)], 1)], 1), _vm._v(" "), _c('menu-add-to-playlist', {
    attrs: {
      "audio": _vm.audio,
      "activator": ("#btn-more-" + _vm._uid),
      "left": ""
    },
    model: {
      value: (_vm.menuAtp),
      callback: function($$v) {
        _vm.menuAtp = $$v
      },
      expression: "menuAtp"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 body-1 truncate mt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "grey--text",
    attrs: {
      "title": _vm.audio.artist
    }
  }, [_vm._v(_vm._s(_vm.audio.artist))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 grey--text caption",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "likes"
  }, [_vm._v("\n                    " + _vm._s(_vm.$nFormat(_vm.audio.likes_count || 0)) + "\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey lighten-1"
    }
  }, [_vm._v("favorite")])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.audio.created_at
    }
  }, [_vm._v(_vm._s(_vm.$timeago().format(_vm.audio.created_at)))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648cecec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioTeaser.vue
// module id = 378
// module chunks = 0